<template>
  <div class="container text-center my-4">
    <h2>¡Registro Completado!</h2>
    <p>Bienvenido, nuevo usuario.</p>
    <router-link to="/" @click="resetProcess" class="btn btn-link">Volver a la Página Inicial</router-link>
  </div>
</template>

<script>
export default {
  name: 'WelcomeScreen',
  methods: {
    resetProcess() {
      this.$emit('reset');
    }
  }
};
</script>
